import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountUserService } from '../service/account.service';
import { delay, map, tap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    user;
    private sessionExpiredShown = false;

    exludePaths: string[] = [
        'https://maps.googleapis.com/maps/api/geocode/json',
        'https://maps.googleapis.com/maps/api/directions/json',
        'https://person-stream.clearbit.com/v2/combined/find',
        'https://api.ipify.org'
    ]
    constructor(public accountUserService: AccountUserService,
        private messageService: MessageService, private router: Router) {
        this.accountUserService.user.subscribe(x => this.user = x);
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(this.addToken(request)).pipe(
            tap({
                next: (event: HttpEvent<any>) => { },
                error: (error) => {
                    if (error instanceof HttpErrorResponse && error.status === 422) {
                        if (request.url.includes('Configuration/Edit')) {
                            return;
                        }
                        // show validation error
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error });
                    }
                    if (
                        error instanceof HttpErrorResponse &&
                        [401].includes(error.status) &&
                        request.url.includes('MiddlewareAPI') &&
                        !this.sessionExpiredShown
                    ) {
                        this.sessionExpiredShown = true;
                        localStorage.clear();
                        localStorage.setItem('sessionExpired', 'sessionInvalid');
                        this.accountUserService.logout(true);
                    }
                }
            })
        );
    }

    addToken(request: HttpRequest<any>): HttpRequest<any> {
        const excludeUrlFound = this.exludePaths.find(exludePath => {
            if (request.url.includes(exludePath)) {
                return true;
            }
        })

        if (environment?.isCookieEnable == true) {
            if (!excludeUrlFound) {
                return request.clone({
                    withCredentials: true,
                    setHeaders: {}
                });
            } else {
                return request;
            }
        }
        else {
            if (this.user && !excludeUrlFound) {
                return request.clone({
                    setHeaders: {
                        ...this.getHeaderLogin(this.user)
                    }
                });
            } else {
                return request;
            }
        }

    }

    getHeaderLogin(user) {
        let randomstr = localStorage.getItem("randomstr");
        return {
            'AccessToken': localStorage.getItem('access_token')
        }
        // return {
        //     'organizationId': user.organizationId + '',
        //     'userId': user.userId + '',
        //     'loginAuditId': user.loginAuditId + '',
        //     'authToken': user.token + '',
        //     'sessionId': randomstr,
        //     'sourceType': 'Web',
        //     'userSource': user.userIP
        // };
    }

}
